import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-neutral-200" data-id="element-20" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-21" data-mp="22div4molhl5j">
        <div className="text-center mb-16" data-id="element-22" data-mp="1ydi8ierce3ne">
          <p className="text-amber-700 font-bold tracking-widest uppercase mb-2" data-id="element-23" data-mp="1yet8s4lkwt9r">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-neutral-900" data-id="element-24" data-mp="15q5ifulz3dpc">
            <span className="text-amber-600" data-id="element-25" data-mp="1jhanjc840y72">5</span> EXCLUSIVE HEAVY EQUIPMENT INSTRUCTOR BONUSES
          </h2>
          <p className="text-lg text-neutral-800/80 max-w-3xl mx-auto mt-5" data-id="element-26" data-mp="1epsjgfasihhv">
            The six main volumes provide your visual machinery training resources. And the five
            professional bonuses provide additional written resources to help you plan lessons,
            organize activities, evaluate knowledge and review student development.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-27" data-mp="2eqwdn0ca5486">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-neutral-200 rounded-2xl p-8 shadow-sm shadow-neutral-900/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="2ji66e9t4knoa" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-neutral-900 text-yellow-400 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-29" data-mp="25r104ov94x4z">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-yellow-50 border border-neutral-300 rounded-full flex items-center justify-center text-amber-600 mb-4" data-id="element-30" data-mp="3h5en7ri6l8jy">
                <Gift size={24} data-id="element-31" data-mp="1h1u6bv6i7i5o" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-neutral-900" data-id="element-32" data-mp="1c4tzvj5qsde1">{bonus.title}</h3>
              <p className="text-amber-700 text-sm font-semibold mb-4 border-l-4 border-amber-500 pl-4" data-id="element-33" data-mp="1q4d7maun5mpt">
                {bonus.subtitle}
              </p>
              {bonus.intro && <p className="text-neutral-800 text-sm mb-4 leading-relaxed" data-id="element-34" data-mp="yce3h17cjdm3">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-35" data-mp="tbzu9fu0dxmh">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-36" data-mp="17729itkqwzby">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-37" data-mp="aliescy6syj2">
                        <CheckCircle2 size={16} className="text-amber-500 shrink-0 mt-0.5" data-id="element-38" data-mp="i3d3wx0sk17" />
                        <span className="text-neutral-800 text-sm" data-id="element-39" data-mp="5bo24zgmy3o9">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.detailedBullets && <>
                  <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-40" data-mp="ja5pgw2mpe5n">{bonus.bulletsIntro}</p>
                  <ul className="mb-6 space-y-3" data-id="element-41" data-mp="o9iki43nlrjb">
                    {bonus.detailedBullets.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-42" data-mp="9chr7w5tdoiq">
                        <CheckCircle2 size={16} className="text-amber-500 shrink-0 mt-0.5" data-id="element-43" data-mp="eajaoi75jpuq" />
                        <div data-id="element-44" data-mp="2u1xg2llh335q">
                          <span className="block text-neutral-900 font-bold text-sm" data-id="element-45" data-mp="2u0w1461c5wiq">{item.title}</span>
                          <span className="block text-neutral-800 text-sm" data-id="element-46" data-mp="2z237c0ntynna">{item.detail}</span>
                        </div>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-47" data-mp="35jesr9v89ref">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-48" data-mp="30hfnfufxgkeu">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-neutral-900 font-semibold text-sm bg-neutral-50 border border-neutral-200 rounded-lg px-3 py-2" data-id="element-49" data-mp="3t7o8bu1ulix4">
                        {bullet}
                      </li>)}
                  </ul>
                </>}

              <div className="mt-auto space-y-3" data-id="element-50" data-mp="2crbmjuu4iyrj">
                {bonus.system && <div data-id="element-51" data-mp="27wplakhraml6">
                    <p className="text-neutral-900 font-semibold text-sm mb-2" data-id="element-52" data-mp="ncu6eyy7n7k1">{bonus.systemLabel}</p>
                    <p className="text-neutral-900 font-bold text-xs sm:text-sm tracking-wide bg-yellow-50 border-l-4 border-amber-500 rounded-lg px-3 py-2" data-id="element-53" data-mp="sbdtj2ojipdz">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-neutral-50 border border-neutral-200 border-l-4 border-l-amber-500 rounded-xl p-4" data-id="element-54" data-mp="170ticd4igkr1">
                    <span className="text-neutral-900 font-bold block mb-1" data-id="element-55" data-mp="1b1dfvhszxqdp">RESULT</span>
                    <p className="text-neutral-800 text-sm" data-id="element-56" data-mp="1g0q1jz84srep">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-neutral-200" data-id="element-57" data-mp="1ky8c1u1sreot">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-neutral-900 font-extrabold text-base tracking-wide' : 'text-neutral-900 font-semibold text-sm italic'} data-id="element-58" data-mp="3mrfo8um45g6h" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}